module.exports = __webpack_public_path__ + "static/media/searchicon-grey-radius.4114d99b.svg";